module.exports = __webpack_public_path__ + "static/media/mist.486da968.svg";